import { Deserializable } from '../deserializable';

export class LookupMediaTypes implements Deserializable{

    public id : number;
    public description: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}